import React from "react";
import { useIntl } from "react-intl";
import { FieldError } from "react-hook-form";
import { Field } from "@smartling-ui/field";
import {
    InputGroup,
    InputGroupAddon,
    InputGroupInput,
    InputGroupText
} from "@smartling-ui/input-group";
import { Briefcase } from "lucide-react";

import { MAX_JOB_TITLE_LENGTH } from "../../constants";
import { ServerErrorMessage } from "../ServerErrorMessage";

import messages from "./messages";

type Props = {
    value: string;
    onChange: (...event: unknown[]) => void;
    onBlur: () => void;
    name: string;
    error?: FieldError;
    inputRef?: React.Ref<HTMLInputElement>;
    autoFocus?: boolean;
}

export function JobTitleField({
    value,
    onChange,
    onBlur,
    name,
    error,
    inputRef,
    autoFocus
}: Props) {
    const intl = useIntl();

    return (
        <Field.Root invalid={!!error}>
            <Field.Label>
                {intl.formatMessage(messages.jobTitle)}
            </Field.Label>

            <InputGroup>
                <InputGroupAddon align="inline-start">
                    <InputGroupText>
                        <Briefcase aria-hidden="true" />
                    </InputGroupText>
                </InputGroupAddon>

                <InputGroupInput
                    aria-invalid={!!error}
                    data-testid="jobTitle"
                    autoComplete="organization-title"
                    placeholder={intl.formatMessage(messages.jobTitlePlaceholder)}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    ref={inputRef}
                    name={name}
                    maxLength={MAX_JOB_TITLE_LENGTH}
                    autoFocus={autoFocus}
                />
            </InputGroup>

            {error && (
                <Field.Error>
                    <ServerErrorMessage error={error} />
                </Field.Error>
            )}
        </Field.Root>
    );
}
